import { Button } from "@/components/ui/button";

/** Replaces the stepper while a prospect is parked. */
export function NurtureBanner({ revisitOn, reason, onResume, pending }: {
  revisitOn: string | null; reason: string | null; onResume: () => void; pending?: boolean;
}) {
  const when = revisitOn ? new Date(revisitOn.slice(0, 10) + "T00:00:00").toLocaleDateString("en-US", { month: "long", year: "numeric" }) : "no date set";
  const due = !!revisitOn && new Date(revisitOn.slice(0, 10) + "T23:59:59").getTime() < Date.now();
  return (
    <div className="flex items-center justify-between gap-3 rounded-lg border border-dashed bg-muted/40 px-4 py-3">
      <div className="text-sm">
        <span className="font-semibold">Nurturing</span> · revisit <b>{when}</b>
        {due && <span className="ml-2 text-amber-700 dark:text-amber-400 font-medium">Revisit due</span>}
        {reason && <div className="text-xs text-muted-foreground mt-0.5">“{reason}”</div>}
      </div>
      <Button size="sm" variant="outline" onClick={onResume} disabled={pending}>Resume</Button>
    </div>
  );
}
